"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiHashTag = /** @class */ (function (_super) {
    __extends(ApiHashTag, _super);
    function ApiHashTag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_HASHTAG_NEW_ID = "/api/hashtag/create";
        _this.GET_HASHTAG_LIST = "/api/hashtag/list";
        _this.GET_HASHTAG = "/api/hashtag/get";
        _this.UPDATE_HASHTAG = "/api/hashtag/set";
        _this.DELETE_HASHTAG = "/api/hashtag/delete";
        /**
         * hashtag 새로운 id 발급
         * @param accesstoken
         * @param language
         * @returns
         */
        _this.getHashTagNewId = function (accesstoken, language, type) {
            var data = {
                language: language,
                type: type,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_HASHTAG_NEW_ID,
                data: data,
            });
        };
        /**
         * hashtag list
         * @param accesstoken
         * @param language
         * @returns
         */
        _this.getHashTagList = function (accesstoken, language, type) {
            var data = {
                language: language,
                type: type,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_HASHTAG_LIST,
                data: data,
            });
        };
        /**
         * hashtag 상세정보
         * @param accesstoken
         * @param id
         * @returns
         */
        _this.getHashTag = function (accesstoken, id) {
            var data = {
                id: id,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_HASHTAG,
                data: data,
            });
        };
        /**
         * hashtag update
         * @param accesstoken
         * @param request
         * @returns
         */
        _this.updateHashTag = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_HASHTAG,
                data: request,
            });
        };
        _this.deleteHashTag = function (accesstoken, id) {
            var data = {
                id: id,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_HASHTAG,
                data: data,
            });
        };
        return _this;
    }
    ApiHashTag.getInstance = function (initValue) {
        if (!ApiHashTag.classInstance) {
            this.classInstance = new ApiHashTag(initValue);
        }
        return this.classInstance;
    };
    return ApiHashTag;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiHashTag;
